/**
 * Utility functions for handling job type format differences
 * in the VA Sprouts application
 */

/**
 * Normalize job type between hyphen and underscore formats
 * @param {string} jobType - The job type to normalize
 * @param {string} format - The desired format ('hyphen' or 'underscore')
 * @returns {string} - The normalized job type
 */
export const normalizeJobTypeFormat = (jobType, format = 'hyphen') => {
  if (!jobType) return jobType;
  
  if (format === 'hyphen') {
    return jobType.replace('_', '-');
  } else {
    return jobType.replace('-', '_');
  }
};

/**
 * Map of job types with their display labels
 */
export const JOB_TYPE_LABELS = {
  'full-time': 'Full Time',
  'part-time': 'Part Time',
  'contract': 'Contract',
  'freelance': 'Freelance',
  'full_time': 'Full Time',
  'part_time': 'Part Time'
};

/**
 * Get display label for a job type
 * @param {string} jobType - The job type value
 * @returns {string} - The display label
 */
export const getJobTypeLabel = (jobType) => {
  return JOB_TYPE_LABELS[jobType] || jobType || 'Unknown';
};

/**
 * DB format job types (with hyphens)
 */
export const DB_JOB_TYPES = ['full-time', 'part-time', 'contract', 'freelance'];

/**
 * UI format job types (with underscores)
 */
export const UI_JOB_TYPES = ['full_time', 'part_time', 'contract', 'freelance'];

export default {
  normalizeJobTypeFormat,
  getJobTypeLabel,
  JOB_TYPE_LABELS,
  DB_JOB_TYPES,
  UI_JOB_TYPES
};
